/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_Tool_Voice_LabelInputs */

const en_tts_tool_voice_label = /** @type {(inputs: Tts_Tool_Voice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voice`)
};

const es_tts_tool_voice_label = /** @type {(inputs: Tts_Tool_Voice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voz`)
};

/**
* | output |
* | --- |
* | "Voice" |
*
* @param {Tts_Tool_Voice_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_voice_label = /** @type {((inputs?: Tts_Tool_Voice_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_Voice_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_voice_label(inputs)
	return en_tts_tool_voice_label(inputs)
});